import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { StudioAuthProvider } from "@/context/StudioAuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Gallery from "@/pages/Gallery";
import AIStudio from "@/pages/AIStudio";
import Configurator from "@/pages/Configurator";
import Commercial from "@/pages/Commercial";
import Consultation from "@/pages/Consultation";
import Estimate from "@/pages/Estimate";
import Pricing from "@/pages/Pricing";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Guides from "@/pages/Guides";
import About from "@/pages/About";
import AreaLanding from "@/pages/AreaLanding";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import ProjectDetail from "@/pages/ProjectDetail";
import NotFound from "@/pages/NotFound";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import StudioLogin from "@/pages/StudioLogin";
import StudioDashboard from "@/pages/StudioDashboard";
import WhatsAppButton from "@/components/WhatsAppButton";
import SchemaManager from "@/components/SchemaManager";
import ChatWidget from "@/components/ChatWidget";
import ConsentBanner from "@/components/ConsentBanner";

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function SmoothScroll() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);
  return null;
}

function SiteChrome({ children }) {
  const { pathname } = useLocation();
  const bare = pathname.startsWith("/admin") || pathname.startsWith("/studio");
  return (
    <>
      {!bare && <Navbar />}
      {children}
      {!bare && <Footer />}
      {!bare && <WhatsAppButton />}
      {!bare && <ChatWidget />}
      {!bare && <ConsentBanner />}
    </>
  );
}

function App() {
  return (
    <div className="App noise">
      <BrowserRouter>
        <AuthProvider>
          <StudioAuthProvider>
            <SmoothScroll />
            <ScrollTop />
            <SchemaManager />
            <Toaster position="top-center" richColors />
            <SiteChrome>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/gallery" element={<Gallery />} />
                <Route path="/projects/:slug" element={<ProjectDetail />} />
                <Route path="/ai-studio" element={<AIStudio />} />
                <Route path="/configurator" element={<Configurator />} />
                <Route path="/commercial" element={<Commercial />} />
                <Route path="/consultation" element={<Consultation />} />
                <Route path="/estimate" element={<Estimate />} />
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/guides" element={<Guides />} />
                <Route path="/about" element={<About />} />
                <Route path="/interior-designers-in/:area" element={<AreaLanding />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/studio" element={<StudioLogin />} />
                <Route path="/studio/dashboard" element={<StudioDashboard />} />
                <Route path="/admin" element={<AdminLogin />} />
                <Route path="/admin/dashboard" element={<AdminDashboard />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </SiteChrome>
          </StudioAuthProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
